<div class="p-fluid p-grid">
  <div class="p-col-12 p-lg-12">
    <p-panel header="Filtros"  [toggleable]="true" [collapsed]="true" *ngIf="dsTelefones && dsTelefones.restricoes">
      <div class="p-fluid p-formgrid p-grid" (keyup)="dsTelefones.onEnterPesquisar($event)">
        <div class="p-field p-col-12 p-md-3">
          <m-restricao-number label="Id" [restricao]="dsTelefones.restricoes.atributo('id')"></m-restricao-number>
        </div>
        <div class="p-field p-col-12 p-md-3">
          <m-restricao-string label="Origem Id" [restricao]="dsTelefones.restricoes.atributo('origemId')"></m-restricao-string>
        </div>
        <div class="p-field p-col-12 p-md-3">
          <m-restricao-string label="Número" [restricao]="dsTelefones.restricoes.atributo('telefone.numero')"></m-restricao-string>
        </div>
        <div class="p-field p-col-3">
          <label class="m-l-8 m-b-1">Tipo:</label>
          <p-dropdown
            placeholder="Selecione..." [options]="pessoaTelefoneTipoItens"
            [(ngModel)]="dsTelefones.restricoes.atributo('telefone.tipo').valor"
            class="p-dropdown-p"
            filter="true">
          </p-dropdown>
        </div>
      </div>
      <ng-template pTemplate="footer">
        <div class="p-fluid p-grid" style="padding-top: 1rem;">
          <div class="p-field p-col-6">
            <button pButton label="Pesquisar" (click)="dsTelefones.pesquisar()"></button>
          </div>
          <div class="p-field p-col-6">
            <button pButton class="p-button-secondary" label="Limpar" (click)="dsTelefones.limpar()"></button>
          </div>
        </div>
      </ng-template>
    </p-panel>
  </div>
</div>
<p-table

    *ngIf="dsTelefones !== undefined"
    [totalRecords]="dsTelefones.total"
    [value]="dsTelefones.entidades"
    (onLazyLoad)="dsTelefones.carregar($event)"
    [(rows)]="dsTelefones.registros"
    [lazy]="true"
    [paginator]="true"
    currentPageReportTemplate="Mostrando {first} de {last} de {totalRecords} registros"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10,25,50,100]"
    [rows]="10"
    paginatorPosition = "bottom"
    responsiveLayout="scroll"
    styleClass="p-datatable-striped">
   <ng-template pTemplate="header">
    <tr>
      <th pSortableColumn="id" class="p-text-center"  style="width: 8rem;"> Id <p-sortIcon field="id"></p-sortIcon></th>
      <th pSortableColumn="origemId" style="width: 160px">Origem Id.<p-sortIcon field="origemId"></p-sortIcon></th>
      <th style="width: 18%">Tipo</th>
      <th>Número</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-pessoaTelefone>
    <tr>
      <td>{{pessoaTelefone.id}}</td>
      <td>{{pessoaTelefone.origemId}}</td>
       <td>{{pessoaTelefone.telefone?.tipo | dominio:'getPessoaCelularTipo'}}</td>
      <td>
        <div [class.excluido]="pessoaTelefone.dataExclusao">{{pessoaTelefone.telefone.numero}}</div>
        <div *ngIf="pessoaTelefone.dataExclusao" class="exclusao-data">
          Excluído em: {{pessoaTelefone.dataExclusao | date: 'dd/MM/yyyy HH:mm:ss'}}
        </div>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage" let-columns>
    <tr>
      <td [attr.colspan]="4">Nenhum telefone cadastrado</td>
    </tr>
  </ng-template>
</p-table>
